export default __webpack_public_path__ + "static/media/Edit.4fa02ba3.svg";